export default "__VITE_ASSET__bba46528__"